import { render, staticRenderFns } from "./AddLevels.vue?vue&type=template&id=387160c9&scoped=true"
import script from "./AddLevels.vue?vue&type=script&lang=js"
export * from "./AddLevels.vue?vue&type=script&lang=js"
import style0 from "./AddLevels.vue?vue&type=style&index=0&id=387160c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387160c9",
  null
  
)

export default component.exports